import React from 'react';
import { Icon, WYSIWYGRenderer } from '@vectord/components';
import { useSelector } from 'react-redux';

import {
  learnerUpdateActionSelector,
  SCHEDULED_CLASSES_VISIBILITY_DATA,
  selectedSuperBatchSelector,
} from 'features/classCreation';

import styles from './ScheduledClassesVisibility.module.scss';

function ScheduledClassesVisibility() {
  const learnerUpdateAction = useSelector(learnerUpdateActionSelector);
  const selectedSuperBatch = useSelector(selectedSuperBatchSelector);
  const { batch_type: batchType } = selectedSuperBatch;

  return (
    <div className={styles.root}>
      <div className={styles.title}>Scheduled Classes</div>
      <div className="p-xs">
        <Icon name="info" />
        <br />
        <WYSIWYGRenderer
          html={
            SCHEDULED_CLASSES_VISIBILITY_DATA[learnerUpdateAction][batchType]
          }
        />
      </div>
    </div>
  );
}

export default ScheduledClassesVisibility;
